import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  EVTextField,
  makeStyles,
} from '@eagleview/ev-comp-library';

const useStyles = makeStyles((theme) => ({
  textfield: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.evPalette.nickel[100],
    color: theme.evPalette.charcoal[900],
    width: theme.spacing(38),
    height: theme.spacing(7),
    borderRadius: theme.spacing(0.5),
  },
  floatingLabelFocusStyle: {
    color: theme.evPalette.nickel[400],
    cursor: 'help',
  },
  helperText: {
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(7),
    color: theme.palette.error.main,
    position: 'absolute',
  },
}));

/**
 * Textfield component is a common component to be used in other components with consistent style.
 */
const Textfield = (props) => {
  const {
    textFieldId, textFieldValue, textFieldLabel, textFieldInputProps, helperText, handleBlur, handleChange,
  } = props;
  const classes = useStyles();

  return (
    <>
      <EVTextField
        id={textFieldId}
        defaultValue={textFieldValue}
        size="small"
        helperText={helperText}
        InputProps={textFieldInputProps}
        className={clsx(classes.textfield)}
        label={textFieldLabel}
        variant="filled"
        onChange={handleChange}
        InputLabelProps={{
          className: classes.floatingLabelFocusStyle,
        }}
        onBlur={handleBlur}
        FormHelperTextProps={{ classes: { contained: classes.helperText } }}
      />
    </>
  );
};

Textfield.propTypes = {
  /**
   * @property {string} textFieldId - id of EVTextField
   */
  textFieldId: PropTypes.string,
  /**
   * @property {string} textFieldValue - value of EVTextField
   */
  textFieldValue: PropTypes.string,
  /**
   * @property {string} textFieldLabel - label of EVTextField
   */
  textFieldLabel: PropTypes.string.isRequired,
  /**
   * @property {object} textFieldInputProps - props applied to the Input element.
   */
  textFieldInputProps: PropTypes.shape(),
  /**
   * @property {string} helperText - string to be displayed in an error state.
   */
  helperText: PropTypes.string,
  /**
   * @property {function} handleBlur - method to be called on blur.
   */
  handleBlur: PropTypes.func,
  /**
   * @property {function} handleChange - method to be called on change.
   */
  handleChange: PropTypes.func,
};

Textfield.defaultProps = {
  textFieldId: '',
  textFieldValue: ' ',
  textFieldInputProps: {},
  helperText: '',
  handleBlur: null,
  handleChange: null,
};

export default Textfield;
